const { getLanguage } = require('./i18n').i18n;

const SPANISH_LANGUAGE_FORMAT_ISO369_ISO3166 = 'es-ES';
const GERMAN_LANGUAGE_FORMAT_ISO369_ISO3166 = 'de-DE';
const ENGLISH_LANGUAGE_FORMAT_ISO369_ISO3166= 'en-ES';
const DUTCH_LANGUAGE_FORMAT_ISO369_ISO3166 = 'nl-NL';
const PORTUGUESE_LANGUAGE_FORMAT_ISO369_ISO3166 = 'pt-PT';

const localizationParser = {
    de: GERMAN_LANGUAGE_FORMAT_ISO369_ISO3166,
    en: ENGLISH_LANGUAGE_FORMAT_ISO369_ISO3166,
    es: SPANISH_LANGUAGE_FORMAT_ISO369_ISO3166,
    nl: DUTCH_LANGUAGE_FORMAT_ISO369_ISO3166,
    pt: PORTUGUESE_LANGUAGE_FORMAT_ISO369_ISO3166
};

const getFormattedLanguage = (isContactCenter, language = getLanguage(isContactCenter)) => localizationParser[language] || SPANISH_LANGUAGE_FORMAT_ISO369_ISO3166;

module.exports = {
    getFormattedLanguage
};
